import React from "react";
import NewCampaignAdminForm from "../../../components/campaigns/admin/NewCampaignAdminForm";
const NewCampaignAdminV2 = () => {
  return (
    <div>
      <NewCampaignAdminForm />
    </div>
  );
};

export default NewCampaignAdminV2;
